import CardCenteredContent from '@shared/components/core/card/CardCenteredContent';
import { useTranslation } from 'react-i18next';

// refactor this if using billing page
// this card will reroute to BillingRedirectPage since it loads the payment link and opens it in a new tab
export default function OrgBillingErrorCard() {
    const { t } = useTranslation();

    return (
        <CardCenteredContent
            name="orgTransaction"
            title={t('common:billing.title')}
            description={t('common:billing.error')}></CardCenteredContent>
    );
}
